import { inject, Injectable } from '@angular/core';
import type { LmivProductSearchResultModel } from '@libs/services/models';
import { AppErrorModel } from '@libs/shared/models';
import { ProductDataModel } from '@libs/shop/models';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { LmivRepositoryService } from './lmiv-repository.service';

@Injectable({ providedIn: 'root' })
export class LmivService {
  private readonly repository: LmivRepositoryService = inject(LmivRepositoryService);

  public searchProduct(productNumber: string): Observable<LmivProductSearchResultModel> {
    return this.repository.getProduct(productNumber).pipe(
      map((product: ProductDataModel): LmivProductSearchResultModel => ({ count: 1, product })),
      catchError((error: AppErrorModel) => {
        if (error.status === 404) {
          return of({ count: 0 } as LmivProductSearchResultModel);
        }

        return throwError(() => error);
      }),
    );
  }
}
